/**
 * Order history skeleton styles shared by PHP-rendered and React-rendered skeleton markup.
 */
.haus-order-history-skeleton {
  display: var(--haus-orderHistory__orderList__display, flex);
  flex-direction: var(--haus-orderHistory__orderList__flex-direction, column);
  align-items: var(--haus-orderHistory__orderList__align-items, flex-start);
  gap: var(--haus-orderHistory__orderList__gap, 1rem);
  padding: var(--haus-orderHistory__orderList__padding, 2rem);
  overflow-x: var(--haus-orderHistory__orderList__overflow-x, auto);
  background: var(--haus-orderHistory__orderList__background, #fff);
}

.haus-order-history-skeleton__slot {
  display: contents;
}

.haus-order-history-skeleton__list {
  display: var(--haus-orderHistory__orderListContent__display, flex);
  flex-direction: var(--haus-orderHistory__orderListContent__flex-direction, column);
  width: var(--haus-orderHistory__orderListContent__width, 100%);
}

.haus-order-history-skeleton__item {
  border-bottom: var(--haus-orderSummary__block__separator-width, 0.0625rem) solid
    var(--haus-orderSummary__block__separator-color, #e5e5e5);
}

.haus-order-history-skeleton__item:last-child {
  border-bottom: var(--haus-orderSummary__block__last__border-bottom, none);
}

.haus-order-history-skeleton__header {
  padding: var(--haus-orderSummary__header__padding, 1rem);
  border-bottom: var(--haus-orderSummary__header__separator-width, 0.0625rem) solid
    var(--haus-orderSummary__header__separator-color, #e5e5e5);
}

.haus-order-history-skeleton__headerInner {
  display: var(--haus-orderSummary__headerInner__display, flex);
  justify-content: var(--haus-orderSummary__headerInner__justify-content, space-between);
  align-items: var(--haus-orderSummary__headerInner__align-items, flex-start);
  gap: var(--haus-orderSummary__headerInner__gap, 1rem);
  flex-wrap: var(--haus-orderSummary__headerInner__flex-wrap, wrap);
}

.haus-order-history-skeleton__headerInfo {
  display: var(--haus-orderSummary__headerInfo__display, flex);
  gap: var(--haus-orderSummary__headerInfo__gap, 1rem);
  flex-wrap: var(--haus-orderSummary__headerInfo__flex-wrap, wrap);
  min-width: var(--haus-orderSummary__headerInfo__min-width, 0);
  width: var(--haus-orderSummary__headerInfo__width, 100%);
  flex-direction: var(--haus-orderSummary__headerInfo__flex-direction, column);
}

.haus-order-history-skeleton__headerBlock {
  display: var(--haus-orderSummary__headerBlock__display, flex);
  flex-direction: var(--haus-orderSummary__headerBlock__flex-direction, row);
  justify-content: var(--haus-orderSummary__headerBlock__justify-content, space-between);
  align-items: var(--haus-orderSummary__headerBlock__align-items, center);
  gap: var(--haus-orderSummary__headerBlock__gap, 0);
  min-width: var(--haus-orderSummary__headerBlock__min-width, 0);
  width: var(--haus-orderSummary__headerBlock__width, 100%);
}

.haus-order-history-skeleton__headerBlock:nth-child(1) {
  flex: 1 1 var(--haus-orderSummary__headerBlock__orderCode__width, auto);
}

.haus-order-history-skeleton__headerBlock:nth-child(2) {
  flex: 1 1 var(--haus-orderSummary__headerBlock__total__width, auto);
}

.haus-order-history-skeleton__headerBlock:nth-child(3) {
  flex: 1 1 var(--haus-orderSummary__headerBlock__date__width, auto);
}

.haus-order-history-skeleton__headerBlock:nth-child(4) {
  flex: 1 1 var(--haus-orderSummary__headerBlock__state__width, auto);
}

/* Desktop layout: headerInfo as row, headerBlocks with label above value */
@media only screen and (min-width: 1025px) {
  .haus-order-history-skeleton__headerInfo {
    flex-direction: var(--haus-orderSummary__headerInfo__desktop__flex-direction, row);
    gap: var(--haus-orderSummary__headerInfo__desktop__gap, 2rem);
    width: var(--haus-orderSummary__headerInfo__desktop__width, auto);
  }

  .haus-order-history-skeleton__headerBlock {
    flex: 0 0 auto;
    flex-direction: var(--haus-orderSummary__headerBlock__desktop__flex-direction, column);
    justify-content: var(--haus-orderSummary__headerBlock__desktop__justify-content, flex-start);
    align-items: var(--haus-orderSummary__headerBlock__desktop__align-items, flex-start);
    gap: var(--haus-orderSummary__headerBlock__desktop__gap, 0.125rem);
    width: auto;
  }

  .haus-order-history-skeleton__headerBlock:nth-child(1) {
    flex: 0 0 var(--haus-orderSummary__headerBlock__desktop__orderCode__width, 12rem);
  }

  .haus-order-history-skeleton__headerBlock:nth-child(2) {
    flex: 0 0 var(--haus-orderSummary__headerBlock__desktop__total__width, 8rem);
  }

  .haus-order-history-skeleton__headerBlock:nth-child(3) {
    flex: 0 0 var(--haus-orderSummary__headerBlock__desktop__date__width, 8rem);
  }

  .haus-order-history-skeleton__headerBlock:nth-child(4) {
    flex: 0 0 var(--haus-orderSummary__headerBlock__desktop__state__width, 8rem);
  }
}

.haus-order-history-skeleton__headerActions {
  display: var(--haus-orderSummary__headerActions__display, flex);
  justify-content: var(--haus-orderSummary__headerActions__justify-content, flex-end);
  gap: var(--haus-orderSummary__headerActions__gap, 0.5rem);
  flex-shrink: var(--haus-orderSummary__headerActions__flex-shrink, 0);
  flex-wrap: var(--haus-orderSummary__headerActions__flex-wrap, wrap);
}

.haus-order-history-skeleton__line,
.haus-order-history-skeleton__button {
  background: var(
    --haus-orderHistorySkeleton__shimmer__background,
    var(--skeleton-bg-shimmer, linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%))
  );
  background-size: var(--haus-orderHistorySkeleton__shimmer__background-size, 200% 100%);
  animation: haus-order-history-skeleton-shimmer
    var(
      --haus-orderHistorySkeleton__shimmer__animation-duration,
      var(--skeleton-animation-duration, 1.5s)
    )
    infinite ease-in-out;
}

.haus-order-history-skeleton__line {
  display: block;
  border-radius: var(
    --haus-orderHistorySkeleton__line__border-radius,
    var(--skeleton-border-radius, 8px)
  );
  min-height: var(--haus-orderHistorySkeleton__line__min-height, 16px);
}

/* Uses design tokens from OrderSummary button variants (showProductsButtonVariant, orderAgainButtonVariant) */
.haus-order-history-skeleton__button {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--haus-orderHistorySkeleton__button__min-width, 88px);
  padding: var(--haus-button-padding);
  min-height: calc(var(--haus-button-line-height, 1.5) * var(--haus-button-font-size, 1rem) + 16px);
  border-radius: var(--haus-button-border-radius);
  border-width: var(
    --haus-orderHistorySkeleton__button__border-width,
    var(--haus-button-border-width, 1px)
  );
  border-style: var(
    --haus-orderHistorySkeleton__button__border-style,
    var(--haus-button-border-style, solid)
  );
  border-color: var(--haus-orderHistorySkeleton__button__border-color, #e5e5e5);
}

@keyframes haus-order-history-skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
